import React from 'react'
import { DashboardLayout } from '../../layouts'
import { Breadcrumb, Pagination } from '../../components'
import { Table } from './components'
import data from './data'

const routes = [
  {
    name: 'Dashboard',
    route: '/dashboard'
  },
  {
    name: 'Our Events',
    route: '/dashboard/events'
  },
  {
    name: 'Event Details',
    route: '/dashboard/events/form'
  }
]

const DashboardGuestList = () => {
  return (
    <DashboardLayout title="Our Events">
      <div className="hidden lg:block">
        <Breadcrumb routes={routes}/>
      </div>
      <div className="flex items-end mt-8 mb-5 lg:mt-2 lg:mb-2">
        <h1 className="text-lg lg:text-4xl font-primary font-bold mr-2 leading-tight lg:leading-none">
          Event Guests
        </h1>
        <p className="font-bold text-xs lg:text-lg">(30/100)</p>
      </div>
      <hr className="hidden lg:block mt-5 mb-8"/>
      <div className="mobile-fullwidth">
        <Table data={data}/>
      </div>
      <Pagination />
    </DashboardLayout>
  )
}

export { DashboardGuestList }